<template>
  <div :style="styles"></div>
</template>

<script>
export default {
  name: 'SafeArea',
  props: {
    top: {
      type: String,
      default: '0px'
    },
    right: {
      type: String,
      default: '0px'
    },
    left: {
      type: String,
      default: '0px'
    },
    bottom: {
      type: String,
      default: '0px'
    }
  },
  computed: {
    styles () {
      return {marginTop: this.top, marginBottom: this.bottom, marginRight: this.right, marginLeft: this.left}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/safe-area.vue